import { useAdministrativeContext } from "../../../../../../../pages/administrativePanel/administrativePanelContext";
import { useCallback, useEffect, useState } from "react"
import { api } from '../../../../../../../services/api'
import { toast } from "react-toastify"
import { SpaceLoader } from '../../../../../../loaders/spaceLoader'
import { useAuth } from "../../../../../../../context/AuthContext"

import { AreaChart, Area, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from "recharts";


export function CancellationsGraphic() {
    const [cancellationsDatas, setCancellationsDatas] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const { signOut } = useAuth()

     
    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext()

    const fetchData = useCallback(async () => {
        let obj = {
            startDate: startDate,
            endDate: endDate,
            business: listBusinessToFilter,
            salesChannels: listSalesChannelsId
        }

   
        try{
            await api.post('/getCancellationsGraphic' , obj, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }).then(response => setCancellationsDatas(response.data))

            setIsLoading(false)

        }catch(error){
            if(error.response){
                if(error.response.status === 401 || error.response.status === 500){
                    signOut()
                    toast.warning('Sua sessão foi expirada')
                }else{
                    toast.error(error.response.data.message)
                }
            }else{
                toast.error(error.message)
            }        
        }

      }, [signOut, startDate, endDate, listBusinessToFilter, listSalesChannelsId])


    useEffect(() => {
        let subscribed = true

        if(subscribed && startDate !== '' && endDate !== '')
            fetchData()

        return () => (subscribed = false)
    }, [fetchData, startDate, endDate])



    if(isLoading){
        return <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)"/>
    }else
        return(
                <>
                {
                    cancellationsDatas.length > 0 ?
                    <ResponsiveContainer  width="98%" height="100%" maxHeight={700} >
                    <AreaChart data={cancellationsDatas} margin={{top: 35}}>


                        <Area dataKey="percent"  stroke="#e05f59" fillOpacity={0} strokeWidth={3}/>


                        <XAxis dataKey="date" axisLine={false} tickLine={false} stroke="var(--colorFontsCardsDashboard)" fontSize="0.55rem"/>

                        <YAxis dataKey='percent' axisLine={false} tickLine={false} tickCount={6} stroke="var(--colorFontsCardsDashboard)" padding={{bottom: 10}} fontSize="0.85rem" 
                        tickFormatter={number => (
                            number + '%'
                        )} 
                        />


                        <CartesianGrid opacity={0.2} vertical={false} stroke="var(--colorFontsCardsDashboard)" />

                    </AreaChart>
                </ResponsiveContainer>
                :<p>Nenhuma informação</p>
            }
            </>
        )
}